var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C2.56815 5.53141 10.4318 5.53141 13 0C12.0383 6.26474 11.8496 12.6912 12.4583 19C9.70181 14.605 3.29819 14.605 0.541667 19C1.74928 12.7424 1.5741 6.29639 0.028399 0.113596L0 0Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterRectangle);
export default __webpack_public_path__ + "static/media/center-rectangle.06a2bf284d4120f8e95a53ceabafa7f6.svg";
export { ForwardRef as ReactComponent };